import React, { Fragment } from "react";
import Header from "../Components/Layout/Header";
import { Box, Container, Grid, Typography } from "@mui/material";
import Footer from "../Components/Layout/Footer";
import { Link } from "react-router-dom";
import banner from "../Assets/about/banner.jpg";
import amir from "../Assets/about/amir.jpg";
import ramezani from "../Assets/about/ramezani.jpg";
import tasadi from "../Assets/about/tasadi.jpg";

const AboutUs = () => {
  const founders = [
    {
      name: "Marziyeh Ramezani",
      pictureUrl: ramezani,
      role: "Founder & Art Director",
      link: "Marziyeh Ramezani",
    },
    {
      name: "Afshin Tasadikari",
      pictureUrl: tasadi,
      role: "Business Director",
      link: "Afshin Tasadikari",
    },
    {
      name: "Amir M. Tasadikari",
      pictureUrl: amir,
      role: "Marketing & Operations Manager",
      link: "",
    },
  ];
  return (
    <Fragment>
      <Box sx={{ width: "100%", position: "relative", pb: 40 }}>
        <Container>
          {" "}
          <Typography variant="h4" component="h2" sx={{ my: 3 }}>
            Brief History
          </Typography>
          <Typography>
            Since its founding in 1993 by Marziyeh Ramezani, Faam Gallery has
            emerged as a leading platform for contemporary visual arts. Over the
            past three decades, it has curated more than 230 solo and group
            exhibitions across a wide range of media, earning a reputation for
            curatorial ambition and artistic excellence. Currently based in
            London, the gallery has consistently maintained an international
            outlook, presenting exhibitions in countries including Italy,
            Germany, China, Dubai, Malaysia, South Korea, and the United
            Kingdom.
            <br /> <br />
            This global perspective has positioned Faam Gallery as a space for
            cultural exchange and cross- border artistic dialogue. Its
            achievements have been recognised internationally, earning awards
            such as a silver medal at China Expo in 2005, a gold medal in 2006,
            and a certificate of recognition at a Seoul exhibition in 2007.
            Beyond exhibitions, the gallery fosters engagement with younger
            audiences through educational workshops and themed festivals.
            <br /> <br />
            In 2016, Faam expanded to London, where it launched a series of
            annual art exhibitions and competitions. Among the most notable was
            25 Centuries of Persian Architecture, which brought together over
            300 artists and, over five years, showcased more than 400 artworks.
            The gallery also organised themed exhibitions such as Freedom, the
            annual Women Exhibition (Afret), Calligraphy, Textures, and
            Jewellery, further broadening its curatorial scope and artistic
            impact.
            <br /> <br />
            In 2019, Faam Gallery opened its permanent space in Whitton,
            Richmond, marking a new chapter in its journey, hosting monthly
            exhibitions and supporting both established and emerging artists.
          </Typography>
          <Typography variant="h4" component="h2" sx={{ my: 3 }}>
            About the founders
          </Typography>
          <Grid
            container
            sx={{ display: "flex", mb: 4, gap: { md: "2.5%", sm: "1%" } }}
          >
            {founders.map((founder: any) => {
              return (
                <Link to={`/artist/${founder.link}`} key={founder.name}>
                  <Grid xs={12} sm={5.9} md={2.8} sx={{ mt: 4 }} item>
                    {founder.pictureUrl ? (
                      <img
                        src={founder.pictureUrl}
                        alt={founder.name}
                        style={{
                          backgroundColor: "gray",
                          width: "100%",
                          aspectRatio: "1",
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          aspectRatio: "1",
                          backgroundColor: "gray",
                        }}
                      ></Box>
                    )}

                    <Typography
                      variant="h6"
                      sx={{ textAlign: "center", color: "#555" }}
                      component="h1"
                    >
                      {founder.name}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{ textAlign: "center", color: "#555" }}
                    >
                      {founder.role}
                    </Typography>
                  </Grid>
                </Link>
              );
            })}
          </Grid>
        </Container>
        <img
          src={banner}
          alt="banner"
          style={{
            width: "100%",
            position: "absolute",
            bottom: 0,
            zIndex: -1,
          }}
        />{" "}
      </Box>
    </Fragment>
  );
};

export default AboutUs;
